<h5 class="title mb-4 text-primary">{{'sessao_v'|translate}}</h5>
<div class="row g-4 mb-4">
    <div class="col-lg-12">
        <div class="form-group">
            <label class="form-label mb-4">{{mdcService.getLabelByCode('mdc_32')}}<span class="text-danger">&nbsp;*</span></label>
            <div class="form-control-wrap">
                <select class="form-select" #mdc_32="ngModel" name="mdc_32" [(ngModel)]="mdcService.formData.mdc_32"
                    [attr.data-msg]="('obrigatorio_error_msg' | translate)" required>
                    <option value="">{{'selct_msg'|translate}}</option>
                    <option *ngFor="let item of mdcService.mdc32options" [value]="item.value">
                        {{item.name}}</option>
                </select>
            </div>
        </div>
    </div>
    <div class="col-lg-12" *ngIf="mdcService.isVisible(['mdc_32_outro'], mdcService.formData.mdc_32! == 6, null)">
        <div class="form-group">
            <input type="text" class="form-control form-control-sm" #mdc_32_outro="ngModel" name="mdc_32_outro"
                [(ngModel)]="mdcService.formData.mdc_32_outro" [attr.data-msg]="('obrigatorio_error_msg' | translate)"
                placeholder="{{'others_placeholder'|translate}}" required>
        </div>
    </div>
    <div class="col-lg-12">
        <div class="form-group">
            <label class="form-label mb-4" for="fw-vr-first-name">{{mdcService.getLabelByCode('mdc_33')}}<span class="text-danger">&nbsp;*</span></label>
            <ul class="custom-control-group g-3 align-center">
                <li *ngFor="let opcao of mdcService.mdc33options">
                    <div class="custom-control custom-control-sm custom-checkbox custom-control-pro">
                        <input type="checkbox" class="custom-control-input mdc_33" [value]="opcao.id"
                            [id]="'mdc_33_' + opcao.id" name="mdc_33" [(ngModel)]="opcao.isSelected"
                            (change)="mdcService.onMultipliClickWithUniqueIdOption(opcao, 'mdc_33', mdcService.mdc33options, 3)"
                            [attr.data-msg]="('obrigatorio_error_msg' | translate)" required
                            (ngModelChange)="mdcService.onCheckboxChange(opcao ,'mdc_33', 'mdc_33_outro', 0)">
                        <label class="custom-control-label" [for]="'mdc_33_' + opcao.id">
                            {{ opcao.name}}</label>
                    </div>
                </li>
            </ul>
        </div>
    </div>
    <div class="col-lg-12"
        *ngIf="mdcService.isVisibleCheckBox(['mdc_34'], this.mdcService.formData.mdc_33.length > 0 && !this.mdcService.formData.mdc_33.includes(3), null, mdcService.mdc34options)">
        <div class="form-group">
            <label class="form-label mb-4" for="fw-vr-first-name">{{mdcService.getLabelByCode('mdc_34')}}<span class="text-danger">&nbsp;*</span></label>
            <ul class="custom-control-group g-3 align-center">
                <li *ngFor="let opcao of mdcService.mdc34options">
                    <div class="custom-control custom-control-sm custom-checkbox custom-control-pro">
                        <input type="checkbox" class="custom-control-input mdc_34" [value]="opcao.id"
                            [id]="'mdc_34_' + opcao.id" name="mdc_34"
                            [attr.data-msg]="('obrigatorio_error_msg' | translate)" required
                            [(ngModel)]="opcao.isSelected"
                            (ngModelChange)="mdcService.onCheckboxChange(opcao, 'mdc_34', 'mdc_34_outro', 4)">
                        <label class="custom-control-label" [for]="'mdc_34_' + opcao.id">
                            {{ opcao.name}}</label>
                    </div>
                </li>
            </ul>
        </div>
    </div>
    <div class="col-lg-12"
        *ngIf="mdcService.isVisible(['mdc_34_outro'], this.mdcService.formData.mdc_34 && this.mdcService.formData.mdc_34.includes(4), null)">
        <div class="form-group">
            <input type="text" class="form-control form-control-sm" #mdc_34_outro="ngModel" name="mdc_34_outro"
                [(ngModel)]="mdcService.formData.mdc_34_outro" [attr.data-msg]="('obrigatorio_error_msg' | translate)"
                placeholder="{{'others_placeholder'|translate}}" required>
        </div>
    </div>
    <div class="col-lg-12">
        <div class="form-group">
            <label class="form-label">{{mdcService.getLabelByCode('mdc_35')}}</label>
            <div class="row g-3 mt-2">
                <div class="col-lg-5 text-lg-end mt-0">
                    <div class="form-group">
                        <label class="form-label mb-4 mb-lg-2">{{mdcService.getLabelByCode('mdc_35_1')}}<span class="text-danger">&nbsp;*</span></label>
                    </div>
                </div>
                <div class="col-lg-7 mt-0 mb-4 mb-lg-0">
                    <ul class="custom-control-group g-3 align-center flex-wrap">
                        <li *ngFor="let item of mdcService.mdcSimNaoOptions">
                            <div class="custom-control custom-radio">
                                <input type="radio" class="custom-control-input" value="{{item.value}}"
                                    id="mdc_35_1_{{item.id}}" [(ngModel)]="mdcService.formData['mdc_35_1']"
                                    name="mdc_35_1" [attr.data-msg]="('obrigatorio_error_msg' | translate)" required>
                                <label class="custom-control-label" for="mdc_35_1_{{item.id}}">{{item.name}}</label>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="row g-3 mt-2" *ngIf="mdcService.isVisible(['mdc_35_2'], mdcService.formData.mdc_35_1! == 1, null)">
                <div class="col-lg-5 text-lg-end mt-0">
                    <div class="form-group">
                        <label class="form-label mb-4 mb-lg-2">{{mdcService.getLabelByCode('mdc_35_2')}}<span class="text-danger">&nbsp;*</span></label>
                    </div>
                </div>
                <div class="col-lg-7 mt-0 mb-4 mb-lg-0">
                    <ul class="custom-control-group g-3 align-center flex-wrap">
                        <li *ngFor="let item of mdcService.mdcSimNaoOptions">
                            <div class="custom-control custom-radio">
                                <input type="radio" class="custom-control-input" id="mdc_35_2_{{item.id}}"
                                    value="{{item.value}}" name="mdc_35_2" [(ngModel)]="mdcService.formData['mdc_35_2']"
                                    [attr.data-msg]="('obrigatorio_error_msg' | translate)" required>
                                <label class="custom-control-label" for="mdc_35_2_{{item.id}}">{{item.name}}</label>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="row g-3 mt-2" *ngIf="mdcService.isVisible(['mdc_35_3'], mdcService.formData.mdc_35_1! == 1, null)">
                <div class="col-lg-5 text-lg-end mt-0">
                    <div class="form-group">
                        <label class="form-label mb-4 mb-lg-2">{{mdcService.getLabelByCode('mdc_35_3')}}<span class="text-danger">&nbsp;*</span></label>
                    </div>
                </div>
                <div class="col-lg-7 mt-0 mb-4 mb-lg-0">
                    <ul class="custom-control-group g-3 align-center flex-wrap">
                        <li *ngFor="let item of mdcService.mdcSimNaoOptions">
                            <div class="custom-control custom-radio">
                                <input type="radio" class="custom-control-input" id="mdc_35_3_{{item.id}}"
                                    value="{{item.value}}" name="mdc_35_3" [(ngModel)]="mdcService.formData['mdc_35_3']"
                                    [attr.data-msg]="('obrigatorio_error_msg' | translate)" required>
                                <label class="custom-control-label" for="mdc_35_3_{{item.id}}">{{item.name}}</label>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="row g-3 mt-2" *ngIf="mdcService.isVisible(['mdc_35_4'], mdcService.formData.mdc_35_1! == 1, null)">
                <div class="col-lg-5 text-lg-end mt-0">
                    <div class="form-group">
                        <label class="form-label mb-4 mb-lg-2">{{mdcService.getLabelByCode('mdc_35_4')}}<span class="text-danger">&nbsp;*</span></label>
                    </div>
                </div>
                <div class="col-lg-7 mt-0 mb-4 mb-lg-0">
                    <ul class="custom-control-group g-3 align-center flex-wrap">
                        <li *ngFor="let item of mdcService.mdcSimNaoOptions">
                            <div class="custom-control custom-radio">
                                <input type="radio" class="custom-control-input" id="mdc_35_4_{{item.id}}"
                                    value="{{item.value}}" name="mdc_35_4" [(ngModel)]="mdcService.formData['mdc_35_4']"
                                    [attr.data-msg]="('obrigatorio_error_msg' | translate)" required>
                                <label class="custom-control-label" for="mdc_35_4_{{item.id}}">{{item.name}}</label>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="row g-3 mt-2" *ngIf="mdcService.isVisible(['mdc_35_5'], mdcService.formData.mdc_35_1! == 1, null)">
                <div class="col-lg-5 text-lg-end mt-0">
                    <div class="form-group">
                        <label class="form-label mb-4 mb-lg-2">{{mdcService.getLabelByCode('mdc_35_5')}}<span class="text-danger">&nbsp;*</span></label>
                    </div>
                </div>
                <div class="col-lg-7 mt-0 mb-4 mb-lg-0">
                    <ul class="custom-control-group g-3 align-center flex-wrap">
                        <li *ngFor="let item of mdcService.mdcSimNaoOptions">
                            <div class="custom-control custom-radio">
                                <input type="radio" class="custom-control-input" id="mdc_35_5_{{item.id}}"
                                    value="{{item.value}}" name="mdc_35_5" [(ngModel)]="mdcService.formData['mdc_35_5']"
                                    [attr.data-msg]="('obrigatorio_error_msg' | translate)" required>
                                <label class="custom-control-label" for="mdc_35_5_{{item.id}}">{{item.name}}</label>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="row g-3 mt-2" *ngIf="mdcService.isVisible(['mdc_35_6'], mdcService.formData.mdc_35_1! == 1, null)">
                <div class="col-lg-5 text-lg-end mt-0">
                    <div class="form-group">
                        <label class="form-label mb-4 mb-lg-2">{{mdcService.getLabelByCode('mdc_35_6')}}<span class="text-danger">&nbsp;*</span></label>
                    </div>
                </div>
                <div class="col-lg-7 mt-0 mb-4 mb-lg-0">
                    <ul class="custom-control-group g-3 align-center flex-wrap">
                        <li *ngFor="let item of mdcService.mdcSimNaoOptions">
                            <div class="custom-control custom-radio">
                                <input type="radio" class="custom-control-input" id="mdc_35_6_{{item.id}}"
                                    value="{{item.value}}" name="mdc_35_6" [(ngModel)]="mdcService.formData['mdc_35_6']"
                                    [attr.data-msg]="('obrigatorio_error_msg' | translate)" required>
                                <label class="custom-control-label" for="mdc_35_6_{{item.id}}">{{item.name}}</label>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
    <div class="col-lg-12">
        <div class="form-group">
            <label class="form-label mb-4">{{mdcService.getLabelByCode('mdc_36')}}<span class="text-danger">&nbsp;*</span></label>
            <div class="form-control-wrap">
                <select class="form-select" #mdc_36="ngModel" name="mdc_36" [(ngModel)]="mdcService.formData.mdc_36"
                    [attr.data-msg]="('obrigatorio_error_msg' | translate)" required>
                    <option value="">{{'selct_msg'|translate}}</option>
                    <option *ngFor="let item of mdcService.mdc36options" [value]="item.value">
                        {{item.name}}</option>
                </select>
            </div>
        </div>
    </div>
    <div class="col-lg-12" *ngIf="mdcService.isVisible(['mdc_37'], this.mdcService.formData.mdc_36! > 1, null)">
        <div class="form-group">
            <label class="form-label mb-4">{{mdcService.getLabelByCode('mdc_37')}}<span class="text-danger">&nbsp;*</span></label>
            <div class="form-control-wrap">
                <input type="number" [attr.data-msg]="('inconsistent_value' | translate)" #mdc_37="ngModel" name="mdc_37"
                    [(ngModel)]="mdcService.formData.mdc_37" placeholder="{{'year_placeholder'|translate}}"
                    maxlength="4" [min]="mdcService.formData.mdc_9 ? mdcService.formData.mdc_9 : mdcService.mdc9_ano_minimo" [max]="mdcService.ano_atual" class="form-control required" required>
            </div>
        </div>
    </div>
    <div class="col-lg-12"
        *ngIf="mdcService.isVisibleCheckBox(['mdc_38'], mdcService.formData.mdc_36! > 1, null, mdcService.mdc38options)">
        <div class="form-group">
            <label class="form-label mb-4" for="fw-vr-first-name">{{mdcService.getLabelByCode('mdc_38')}}<span class="text-danger">&nbsp;*</span></label>
            <ul class="custom-control-group g-3 align-center">
                <li *ngFor="let opcao of mdcService.mdc38options">
                    <div class="custom-control custom-control-sm custom-checkbox custom-control-pro">
                        <input type="checkbox" class="custom-control-input" [value]="opcao.id"
                            [id]="'mdc_38_' + opcao.id" name="mdc_38" required [(ngModel)]="opcao.isSelected"
                            (ngModelChange)="mdcService.onCheckboxChange(opcao, 'mdc_38', 'mdc_38_outro', 8)">
                        <label class="custom-control-label" [for]="'mdc_38_' + opcao.id">
                            {{ opcao.name}}</label>
                    </div>
                </li>
            </ul>
        </div>
    </div>
    <div class="col-lg-12"
        *ngIf="mdcService.isVisible(['mdc_38_outro'], this.mdcService.formData.mdc_38 && this.mdcService.formData.mdc_38.includes(8), null)">
        <div class="form-group">
            <input type="text" class="form-control form-control-sm" #mdc_38_outro="ngModel" name="mdc_38_outro"
                [(ngModel)]="mdcService.formData.mdc_38_outro" [attr.data-msg]="('obrigatorio_error_msg' | translate)"
                placeholder="{{'others_placeholder'|translate}}" required>
        </div>
    </div>
    <div class="col-lg-12" *ngIf="mdcService.isVisible(['mdc_39'], this.mdcService.formData.mdc_36! > 1, null)">
        <div class="form-group">
            <label class="form-label mb-4">{{mdcService.getLabelByCode('mdc_39')}}<span class="text-danger">&nbsp;*</span></label>
            <div class="form-control-wrap">
                <select class="form-select" #mdc_39="ngModel" name="mdc_39" [(ngModel)]="mdcService.formData.mdc_39"
                    [attr.data-msg]="('obrigatorio_error_msg' | translate)" required>
                    <option value="">{{'selct_msg'|translate}}</option>
                    <option *ngFor="let item of mdcService.mdc39options" [value]="item.value">
                        {{item.name}}</option>
                </select>
            </div>
        </div>
    </div>
    <div class="col-lg-12" *ngIf="mdcService.isVisible(['mdc_39_outro'], mdcService.formData.mdc_39! == 6, null)">
        <div class="form-group">
            <input type="text" class="form-control form-control-sm" #mdc_39_outro="ngModel" name="mdc_39_outro"
                [(ngModel)]="mdcService.formData.mdc_39_outro" [attr.data-msg]="('obrigatorio_error_msg' | translate)"
                placeholder="{{'others_placeholder'|translate}}" required>
        </div>
    </div>
</div>